export default "__VITE_ASSET__1eb44539__"